export default __webpack_public_path__ + "static/media/delete.a396c09e.svg";